import Lottie from 'lottie-react';
import fireworkAnimation from '@/assets/animation/FireWorks.json';

interface ConnectionAnimateProps {
  isPcSize: boolean;
}

const ConnectionAnimate = ({ isPcSize }: ConnectionAnimateProps) => {
  return (
    <section className="flex">
      <Lottie
        animationData={fireworkAnimation}
        className={`${isPcSize ? ' w-[40px]' : 'w-[64px]'}`}
        loop
      />
    </section>
  );
};

export default ConnectionAnimate;
